import React from 'react'
import Layout from '../components/layout'
import { graphql, Link } from 'gatsby'
import BlogTag from '../components/blogtag'
import tagStyles from './tag.module.scss'

export const query = graphql`
query($tag: [String]!) {
    allMarkdownRemark(
        filter: { frontmatter: { tags: { in: $tag } } }
        sort: { order: DESC, fields: [frontmatter___date] }
      ) {
        totalCount
        edges {
          node {
            id
            frontmatter {
              title
              date
              tags
            }
            fields {
                slug
            }
          }
        }
      }
    }
`
const Tag = ({ pageContext, data }) => {
    const { tag } = pageContext // Get tag
    const edges = data.allMarkdownRemark.edges
    return (
        <Layout>
            <h1>{tag}</h1>
            {edges.map(edge => {
                const node = edge.node
                const title = node.frontmatter.title
                const slug = node.fields.slug
                return (
                    <div className={tagStyles.post}>
                        <Link to={`/blog/${slug}`} className={tagStyles.title}><h2>{title}</h2></Link>
                        <h4>最終更新日：{node.frontmatter.date}</h4>
                    <BlogTag tags={node.frontmatter.tags} key={node.id}/>
                    </div>
                )
            })}
            {/* <h2>{edges.edges[0].node.frontmatter.date}</h2> */}
        </Layout>
    )
}

export default Tag